import { useData } from "./DataContext.js";

import DocumentDraggable from "./DocumentDraggable.js";
import StrictModeDroppable from "./StrictModeDroppable.js";

export default function VariableDroppable (props)
{
    const gData = useData();
    
    const documentIds = gData.state.reports[props.solutionId].variables[props.variableId][props.value].documentIds;
    //const documentDroppables = documentIds[props.num] === undefined ? (<></>) : (<DocumentDraggable index={0} documentId={documentIds[props.num]} value={props.value}/>);
    //const droppableId = props.solutionId + "/" + props.variableId + "/" + props.value + "/" + props.num;
    const documentDroppables = documentIds.map((documentId, index) => (<DocumentDraggable key={documentId} index={index} documentId={documentId} variableId={props.variableId} value={props.value}/>));
    const droppableId = props.solutionId + "/" + props.variableId + "/" + props.value;
    const disabled = gData.content.params.easyInvestment && props.draggedDocumentId !== null && gData.content.documents[props.draggedDocumentId].variableId === null;

    const width = gData.content.params.documentWidth + 4*2 || "auto";
    const height = gData.content.params.documentHeight * 2 + 4*3 || "auto";
    
    return (
	<StrictModeDroppable droppableId={droppableId} isDropDisabled={disabled}>
	    {(provided, snapshot) => {
		const isDraggingOver = snapshot.isDraggingOver && ! (gData.content.params.easyInvestment && gData.content.documents[snapshot.draggingOverWith].variableId === null);
		const borderColor = props.value === "pos" ? "success" : "danger";
		const bgColor = isDraggingOver ? (props.value === "pos" ? "bg-success-subtle " : "bg-danger-subtle ") : "bg-white ";

		return (
		    <div className={"border border-0 rounded rounded-1 overflow-hidden m-0 p-1 gap-0 d-flex flex-column align-items-start " + bgColor} style={{ width, height, outline: "2px solid var(--bs-"+borderColor+"-border-subtle)" }}
			 ref={provided.innerRef} { ...provided.droppableProps }
		    >
			{documentDroppables}
			{provided.placeholder}
		    </div>
		);
	    }}
	</StrictModeDroppable>
    );
}
